import React from "react"
import "../styles/social-medias.scss"

const SocialMedias = () => {
  return (
    <div className="social-medias">
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.instagram.com/mr.__.t/"
      >
        {" "}
        <img alt="thoms morice instagram" src="/social/instagram.svg" />{" "}
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/in/thomasmorice/"
      >
        {" "}
        <img alt="thoms morice linkedIn" src="/social/linked-in.svg" />{" "}
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="mailto:t.morice4@gmail.com?subject=Hello Thomas!"
      >
        {" "}
        <img alt="thoms morice mail" src="/social/gmail.svg" />{" "}
      </a>
    </div>
  )
}

export default SocialMedias
